<template>
    <div class="contents">
        <div class="crm">
            <div class="container-fluid">
                <!-- Announcement Section -->
                <div class="row mb-4" v-if="announcementText">
                    <div class="col-12">
                        <div class="alert alert-success alert-dismissible fade show announcement-card" role="alert">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-bullhorn me-3 announcement-icon"></i>
                                <div>
                                    <h6 class="alert-heading mb-2"><strong>PENGUMUMAN</strong></h6>
                                    <div v-html="announcementText" class="announcement-text"></div>
                                </div>
                            </div>
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <!-- Package Status Banner -->
                <div class="row mb-4" v-if="!myPackageLoading">
                    <div class="col-12">
                        <div class="package-status-card">
                            <div class="card-body">
                                <div class="package-header">
                                    <div class="package-main-info">
                                        <h2 class="package-title">{{ $t('dashboard.upgrade_your_package') }}</h2>
                                        <div class="package-name-badge">{{ myPackage.name }}</div>
                                    </div>
                                    <div class="package-action">
                                        <a href="billing" class="btn btn-upgrade">
                                            <i class="fas fa-arrow-up me-2"></i>
                                            {{ $t('global.buy') }} / {{ $t('global.extend') }}
                                        </a>
                                    </div>
                                </div>

                                <div class="package-content">
                                    <div class="package-features-grid">
                                        <div class="feature-item">
                                            <div class="feature-icon">
                                                <i class="fas fa-comment text-success"></i>
                                            </div>
                                            <div class="feature-details">
                                                <div class="feature-value">{{ myPackage.pesan }}</div>
                                                <div class="feature-label">{{ $t('dashboard.message') }}</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">
                                                <i class="fas fa-mobile-alt text-primary"></i>
                                            </div>
                                            <div class="feature-details">
                                                <div class="feature-value">{{ myPackage.device }}</div>
                                                <div class="feature-label">{{ $t('dashboard.device') }}</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">
                                                <i class="fas fa-headset text-info"></i>
                                            </div>
                                            <div class="feature-details">
                                                <div class="feature-value">{{ myPackage.customer_service }}</div>
                                                <div class="feature-label">{{ $t('dashboard.customer_service') }}</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">
                                                <i class="fas fa-bullhorn text-warning"></i>
                                            </div>
                                            <div class="feature-details">
                                                <div class="feature-value">{{ myPackage.campaign }}</div>
                                                <div class="feature-label">{{ $t('dashboard.campaign') }}</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">
                                                <i class="fas fa-link text-secondary"></i>
                                            </div>
                                            <div class="feature-details">
                                                <div class="feature-value">{{ myPackage.link_rotator }}</div>
                                                <div class="feature-label">{{ $t('dashboard.link_rotator') }}</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">
                                                <i class="fas fa-comments text-success"></i>
                                            </div>
                                            <div class="feature-details">
                                                <div class="feature-value">{{ myPackage.chat_widget }}</div>
                                                <div class="feature-label">{{ $t('dashboard.chat_widget') }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="package-expiry-section">
                                        <div class="expiry-notice">
                                            <i class="fas fa-clock"></i>
                                            <div class="expiry-text">
                                                <span class="expiry-label">{{ $t('dashboard.your_package_expired_at') }}</span>
                                                <span class="expiry-date">{{ myPackage.expired_at }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Loading State for Package -->
                <div class="row mb-4" v-else>
                    <div class="col-12">
                        <div class="package-status-card">
                            <div class="card-body text-center py-5">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <p class="mt-3 text-muted">Memuat informasi paket...</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Page Header -->
                <div class="row mb-4">
                    <div class="col-lg-9">
                        <div class="page-header">
                            <h1 class="page-title">{{ $t("dashboard.dashboard") }}</h1>
                            <p class="page-subtitle">Selamat datang di dashboard Starsender</p>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="date-filter">
                            <label class="form-label">Pilih Tanggal</label>
                            <v-date-picker class="inline-block h-full" v-model="filter.date" mode="date" :show-current="true">
                                <template v-slot="{ inputValue, togglePopover }">
                                    <div class="input-group">
                                        <input @focus="togglePopover()" :value="inputValue" class="form-control date-input" placeholder="Pilih tanggal" />
                                        <button class="btn btn-outline-secondary" type="button" @click="togglePopover()">
                                            <i class="fas fa-calendar"></i>
                                        </button>
                                    </div>
                                </template>
                            </v-date-picker>
                        </div>
                    </div>
                </div>

                <!-- Statistics Cards -->
                <div class="row mb-4">
                    <!-- Today's Overview -->
                    <div class="col-lg-6 mb-4">
                        <div class="stats-card overview-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <div class="card-icon me-3" style="margin-inline-end:5px">
                                        <i class="fas fa-chart-line"></i>
                                    </div>
                                    <h5 class="card-title mb-0">{{ $t("dashboard.today_overview") }}</h5>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="stats-item" @click="$router.push('/outgoing')" style="cursor:pointer" title="Lihat daftar pesan terkirim">
                                    <div class="stats-info">
                                        <span class="stats-number" id="outgoing">{{ statistics.message_sent }}</span>
                                        <span class="stats-label">{{ $t("dashboard.today_outgoing") }} <i class="fas fa-chevron-right small text-muted"></i></span>
                                    </div>
                                    <div class="stats-icon">
                                        <i class="fas fa-paper-plane text-primary"></i>
                                    </div>
                                </div>
                                <div class="stats-item" @click="$router.push('/incoming')" style="cursor:pointer" title="Lihat daftar pesan masuk">
                                    <div class="stats-info">
                                        <span class="stats-number" id="incoming">{{ statistics.incoming_message }}</span>
                                        <span class="stats-label">{{ $t("dashboard.today_incoming") }} <i class="fas fa-chevron-right small text-muted"></i></span>
                                    </div>
                                    <div class="stats-icon">
                                        <i class="fas fa-inbox text-success"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Contact Count -->
                    <div class="col-lg-6 mb-4">
                        <div class="stats-card contact-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <div class="card-icon me-3" style="margin-inline-end:5px">
                                        <i class="fas fa-users"></i>
                                    </div>
                                    <h5 class="card-title mb-0">{{ $t('global.contact') }}</h5>
                                </div>
                            </div>
                            <div class="card-body text-center">
                                <div class="contact-number">
                                    <span id="contact">{{ contact }}</span>
                                </div>
                                <p class="contact-label">Total Kontak</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Message Statistics Chart -->
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="chart-card">
                            <div class="card-header">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex align-items-center">
                                        <div class="card-icon me-3" style="margin-inline-end:5px">
                                            <i class="fas fa-chart-pie"></i>
                                        </div>
                                        <h5 class="card-title mb-0">{{ $t("dashboard.message_sent") }}</h5>
                                    </div>
                                    <div class="chart-tabs">
                                        <ul class="nav nav-pills" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" href="#rb_device-today" data-toggle="tab" id="rb_device-today-tab" role="tab" aria-selected="true">
                                                    {{ $t("dashboard.today") }}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="tab-content">
                                    <div class="tab-pane fade active show" id="rb_device-today" role="tabpanel" aria-labelledby="rb_device-today-tab">
                                        <div class="row align-items-center">
                                            <div class="col-lg-6 text-center">
                                                <div class="chart-container">
                                                    <Doughnut :chart-options="chartOptions" :chart-data="chartData" :width="250" :height="250" />
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="chart-legend">
                                                    <div class="legend-item">
                                                        <div class="legend-color sent"></div>
                                                        <div class="legend-info">
                                                            <span class="legend-number" id="terkirim">{{ statistics.message_sent }}</span>
                                                            <span class="legend-label">{{ $t("dashboard.sent") }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="legend-item">
                                                        <div class="legend-color pending"></div>
                                                        <div class="legend-info">
                                                            <span class="legend-number" id="pending">{{ statistics.message_pending }}</span>
                                                            <span class="legend-label">{{ $t("dashboard.pending") }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="legend-item">
                                                        <div class="legend-color failed"></div>
                                                        <div class="legend-info">
                                                            <span class="legend-number" id="gagal">{{ statistics.message_failed }}</span>
                                                            <span class="legend-label">{{ $t("dashboard.failed") }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Popup Modal -->
        <modal name="Popup" :height="'auto'" :adaptive="true" :scrollable="true">
            <div class="popup-modal">
                <button v-on:click="hidePopup" type="button" class="close element-top-right" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="popup-content">
                    <div v-if="popup.title" class="popup-header">
                        <h2>{{ popup.title }}</h2>
                    </div>
                    <div v-if="popup.file" class="popup-image">
                        <img :src="popup.file" alt="" class="img-fluid">
                    </div>
                    <div class="popup-text">
                        <p>{{ popup.text }}</p>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import moment from 'moment'
    import {
        Doughnut
    } from 'vue-chartjs/legacy'
    import {
        Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        CategoryScale
    } from 'chart.js'

    ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

    export default {
        components: {
            Doughnut
        },
        data() {
            return {
                myPackageLoading: true,
                myPackage: {
                    name: "",
                    pesan: "0",
                    device: "0",
                    customer_service: "0",
                    campaign: "0",
                    order_online: "0",
                    link_rotator: "0",
                    chat_widget: "0",
                    expired_at: "",
                    webhook_media_quota:"0"
                },
                statistics: {
                    message_sent: 0,
                    message_pending: 0,
                    message_failed: 0,
                    incoming_message: 0,
                },
                contact: 0,
                filter: {
                    date: moment().format("YYYY-MM-DD"),
                },
                chartData: {
                    labels: ['Terkirim', 'Pending', 'Gagal'],
                    datasets: [{
                        backgroundColor: ['#20c997', '#fa8b0c', '#e24c4b'],
                        data: [0, 0, 0]
                    }]
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false
                },
                announcementText: null,
                popup: {
                    title: null,
                    file: null,
                    text: null
                }
            }
        },
        watch: {
            filter: {
                handler(val) {
                    this.fetchStatistics(moment.utc(val.date).local().format("YYYY-MM-DD"))
                },
                deep: true
            },
        },
        mounted() {
            this.fetchPacakge()
            this.fetchStatistics()
            this.fetchAnnouncement()
            this.fetchPopup()
        },
        methods: {
            async fetchStatistics(date = null) {
                try {
                    let p = await this.$store.dispatch('user_statistics', {
                        date: date ?? this.filter.date
                    })
                    this.statistics = p.data.data.statistics
                    this.contact = p.data.data.contact
                    this.chartData.datasets[0].data = [this.statistics.message_sent, this.statistics
                        .message_pending, this.statistics.message_failed
                    ]
                } catch (err) {
                    console.log(err)
                }
            },
            async fetchPacakge() {
                this.myPackageLoading = true
                try {
                    let p = await this.$store.dispatch('user_myPackage')
                    p = p.data.data.user_package
                    this.myPackage.name = p.package_data.name
                    this.myPackage.pesan = p.message_quota == "-1" ? "Unlimited" : p.message_quota
                    this.myPackage.device = p.max_device == "-1" ? "Unlimited" : p.max_device
                    this.myPackage.customer_service = p.max_cs == "-1" ? "Unlimited" : p.max_cs
                    this.myPackage.campaign = p.max_campaign == "-1" ? "Unlimited" : p.max_campaign
                    this.myPackage.order_online = p.max_order_online == "-1" ? "Unlimited" : p.max_order_online
                    this.myPackage.link_rotator = p.max_link_rotator == "-1" ? "Unlimited" : p.max_link_rotator
                    this.myPackage.chat_widget = p.max_chat_widget == "-1" ? "Unlimited" : p.max_chat_widget
                    this.myPackage.expired_at = moment.unix(p.expired_at / 1000).format('D MMMM YYYY')
                    this.myPackage.webhook_media_quota = (parseInt(p.webhook_media_quota)/1000000) + " GB"
                } catch (err) {
                    console.log(err)
                }
                this.myPackageLoading = false
            },
            async fetchAnnouncement() {
                try {
                    let announcement = await this.$store.dispatch('admin_announcement')
                    this.announcementText = announcement?.data?.data?.announcement?.text ?? null
                } catch (err) {
                    console.log(err)
                }
            },
            async fetchPopup() {
                try {
                    let popupLocal = await this.getWithExpiry("popup")

                    if(popupLocal) return true

                    let popup = await this.$store.dispatch('admin_popup')

                    if(popup?.data?.data?.popup?.id != 0){
                        this.popup = popup?.data?.data?.popup
                        this.$modal.toggle("Popup");

                        this.setWithExpiry("popup", true, 1000 * 60 * 60 * 24)
                    }
                } catch (err) {
                    console.log(err)
                }
            },
            hidePopup(){
                this.$modal.toggle("Popup");
            },
            setWithExpiry(key, value, ttl) {
                const now = new Date()

                // `item` is an object which contains the original value
                // as well as the time when it's supposed to expire
                const item = {
                    value: value,
                    expiry: now.getTime() + ttl,
                }
                localStorage.setItem(key, JSON.stringify(item))
            },
            getWithExpiry(key) {
                const itemStr = localStorage.getItem(key)
                // if the item doesn't exist, return null
                if (!itemStr) {
                    return null
                }
                const item = JSON.parse(itemStr)
                const now = new Date()
                // compare the expiry time of the item with the current time
                if (now.getTime() > item.expiry) {
                    // If the item is expired, delete the item from storage
                    // and return null
                    localStorage.removeItem(key)
                    return null
                }
                return item.value
            }
        }
    }
</script>

<style scoped>
/* General Layout */
/* .contents {
    background-color: #f8f9fa;
    min-height: 100vh;
    padding: 20px 0;
} */

.crm {
    margin-top:10px;
    background-color: #f8f9fa;
}

/* Announcement Card */
.announcement-card {
    background: #E8F5E8;
    border: 1px solid #C8E6C9;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.announcement-icon {
    font-size: 1.5rem;
    color: #155724;
}

.announcement-text {
    color: #155724;
    font-size: 0.95rem;
    line-height: 1.5;
}

/* Package Status Card */
.package-status-card {
    background: #4A90E2;
    border: none;
    border-radius: 16px;
    color: white;
    box-shadow: 0 4px 16px rgba(74, 144, 226, 0.3);
}

.package-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.package-main-info {
    flex: 1;
}

.package-title {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 10px;
    color: white;
}

.package-name-badge {
    display: inline-block;
    background: #FFFFFF;
    color: #4A90E2;
    padding: 8px 16px;
    border-radius: 25px;
    font-size: 1.1rem;
    font-weight: 600;
    border: 2px solid #FFFFFF;
}



.package-features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
}

.feature-item {
    display: flex;
    align-items: center;
    background: #FFFFFF;
    padding: 15px;
    border-radius: 12px;
    border: 2px solid #E3F2FD;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.feature-item:hover {
    background: #F8F9FA;
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.feature-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    font-size: 1.1rem;
    color: white;
}

.feature-details {
    flex: 1;
}

.feature-value {
    font-size: 1.2rem;
    font-weight: 700;
    color: #2C3E50;
    line-height: 1;
    margin-bottom: 2px;
}

.feature-label {
    font-size: 0.85rem;
    color: #6C757D;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.package-expiry-section {
    border-top: 2px solid #E3F2FD;
    padding-top: 20px;
}

.expiry-notice {
    display: flex;
    align-items: center;
    background: #FFF3CD;
    padding: 15px 20px;
    border-radius: 12px;
    border: 2px solid #FFEAA7;
}

.expiry-notice i {
    font-size: 1.2rem;
    color: #856404;
    margin-right: 15px;
}

.expiry-text {
    flex: 1;
}

.expiry-label {
    display: block;
    font-size: 0.9rem;
    color: #856404;
    margin-bottom: 2px;
}

.expiry-date {
    font-size: 1.1rem;
    font-weight: 600;
    color: #2C3E50;
}

.btn-upgrade {
    background: #4A90E2;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 25px;
    font-weight: 600;
    font-size: 1rem;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.btn-upgrade:hover {
    background: #3A7BC8;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(74, 144, 226, 0.3);
}

/* Page Header */
.page-header {
    background: white;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e9ecef;
}

.page-title {
    font-size: 2.2rem;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 8px;
}

.page-subtitle {
    color: #6c757d;
    font-size: 1rem;
    margin: 0;
}

/* Date Filter */
.date-filter {
    background: white;
    padding: 25px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e9ecef;
}

.form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 12px;
}

.date-input {
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 10px 15px;
    font-size: 0.9rem;
}

.input-group .btn {
    border-radius: 0 8px 8px 0;
    border-left: none;
}

/* Statistics Cards */
.stats-card {
    background: white;
    border: none;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    height: 100%;
}

.stats-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.stats-card .card-header {
    background: transparent;
    border-bottom: 1px solid #f1f3f4;
    padding: 20px 25px 15px;
}

.card-icon {
    width: 50px;
    height: 50px;
    background: #4A90E2;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.2rem;
}

.card-title {
    color: #2c3e50;
    font-weight: 600;
    font-size: 1.1rem;
}

.stats-card .card-body {
    padding: 20px 25px 25px;
}

.stats-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #f8f9fa;
}

.stats-item:last-child {
    border-bottom: none;
}

.stats-info {
    display: flex;
    flex-direction: column;
}

.stats-number {
    font-size: 2rem;
    font-weight: 700;
    color: #4A90E2;
    line-height: 1;
}

.stats-label {
    color: #6c757d;
    font-size: 0.9rem;
    margin-top: 5px;
}

.stats-icon {
    width: 50px;
    height: 50px;
    background: #f8f9fa;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
}

/* Contact Card */
.contact-card .card-body {
    text-align: center;
    padding: 30px 25px;
}

.contact-number {
    font-size: 3.5rem;
    font-weight: 700;
    color: #28a745;
    line-height: 1;
    margin-bottom: 10px;
}

.contact-label {
    color: #6c757d;
    font-size: 1rem;
    margin: 0;
}

/* Chart Card */
.chart-card {
    background: white;
    border: none;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.chart-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.chart-card .card-header {
    background: transparent;
    border-bottom: 1px solid #f1f3f4;
    padding: 20px 25px 15px;
}

.chart-tabs .nav-pills .nav-link {
    color: #6c757d;
    border-radius: 20px;
    padding: 8px 16px;
    font-size: 0.9rem;
    font-weight: 500;
}

.chart-tabs .nav-pills .nav-link.active {
    background: #4A90E2;
    color: white;
}

.chart-card .card-body {
    padding: 30px 25px;
}

.chart-container {
    margin: 20px 0;
}

.chart-legend {
    padding: 20px 0;
}

.legend-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.legend-item:hover {
    background: #e9ecef;
    transform: translateX(5px);
}

.legend-color {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 15px;
}

.legend-color.sent {
    background: #20c997;
}

.legend-color.pending {
    background: #fa8b0c;
}

.legend-color.failed {
    background: #e24c4b;
}

.legend-info {
    display: flex;
    flex-direction: column;
}

.legend-number {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2c3e50;
    line-height: 1;
}

.legend-label {
    color: #6c757d;
    font-size: 0.9rem;
    margin-top: 3px;
}

/* Popup Modal */
.popup-modal {
    background: white;
    border-radius: 16px;
    padding: 30px;
    position: relative;
    max-width: 600px;
    margin: 20px auto;
}

.popup-header {
    text-align: center;
    margin-bottom: 20px;
}

.popup-header h2 {
    color: #2c3e50;
    font-weight: 600;
}

.popup-image {
    text-align: center;
    margin: 20px 0;
}

.popup-image img {
    max-width: 100%;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.popup-text {
    color: #495057;
    line-height: 1.6;
    font-size: 1rem;
}

/* Close Button */
.element-top-right {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 10;
    background: #f8f9fa;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: #6c757d;
    transition: all 0.3s ease;
}

.element-top-right:hover {
    background: #e9ecef;
    color: #495057;
}

/* Responsive Design */
@media (max-width: 768px) {
    .contents {
        padding: 15px 0;
    }

    .package-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
    }

    .package-title {
        font-size: 1.5rem;
    }

    .package-features-grid {
        grid-template-columns: 1fr;
        gap: 15px;
    }

    .feature-item {
        padding: 12px;
    }

    .feature-icon {
        width: 35px;
        height: 35px;
        margin-right: 12px;
    }

    .feature-value {
        font-size: 1.1rem;
    }

    .expiry-notice {
        padding: 12px 15px;
    }

    .page-title {
        font-size: 1.8rem;
    }

    .stats-number {
        font-size: 1.5rem;
    }

    .contact-number {
        font-size: 2.5rem;
    }

    .chart-container {
        margin: 10px 0;
    }
}

@media (max-width: 576px) {
    .crm {
        /* Prevent content from being hidden behind fixed header on mobile */
        margin-top: 70px;
    }

    .package-status-card {
        border-radius: 12px;
    }

    .package-header {
        margin-bottom: 20px;
    }

    .package-title {
        font-size: 1.3rem;
    }

    .package-name-badge {
        font-size: 1rem;
        padding: 6px 12px;
    }

    .package-features-grid {
        gap: 12px;
    }

    .feature-item {
        padding: 10px;
        flex-direction: column;
        text-align: center;
    }

    .feature-icon {
        margin-right: 0;
        margin-bottom: 8px;
        width: 45px;
        height: 45px;
    }

    .feature-details {
        text-align: center;
    }

    .expiry-notice {
        flex-direction: column;
        text-align: center;
        padding: 15px;
    }

    .expiry-notice i {
        margin-right: 0;
        margin-bottom: 8px;
    }

    .page-header,
    .date-filter {
        padding: 20px;
    }

    .stats-card .card-header,
    .stats-card .card-body {
        padding: 15px 20px;
    }

    .chart-card .card-header,
    .chart-card .card-body {
        padding: 20px;
    }
}

/* Loading States */
.spinner-border {
    width: 3rem;
    height: 3rem;
}

/* Utility Classes */
.text-primary {
    color: #4A90E2 !important;
}

.text-success {
    color: #28a745 !important;
}

.text-info {
    color: #17a2b8 !important;
}

.text-warning {
    color: #ffc107 !important;
}

.text-danger {
    color: #dc3545 !important;
}

.text-secondary {
    color: #6c757d !important;
}

/* Hover Effects */
.card:hover {
    transition: all 0.3s ease;
}

.btn:hover {
    transition: all 0.3s ease;
}

/* Focus States */
.btn:focus,
.form-control:focus {
    box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.25);
    border-color: #4A90E2;
}

/* Smooth Transitions */
* {
    transition: all 0.3s ease;
}
</style>
